import { ActionItemKeys, NotificationResponse } from '@uplift/api';
import { UserRole } from '@uplift/types';

import { makeTrackingFunction } from '../use-freshpaint';

export const enum ToDoEvent {
  clickedToDoCTA = 'clicked_to_do_cta',
  clickedDismissedToDo = 'clicked_dismiss_to_do',
  clickedSnoozeToDo = 'clicked_snooze_to_do',
  confirmedToDoCTA = 'confirmed_to_do_cta',
  confirmedToDoDismissal = 'confirmed_to_do_dismissal'
}

type ClickedToDoCTA = {
  eventName: ToDoEvent.clickedToDoCTA;
  payload: {
    toDoType: ActionItemKeys;
    userType: UserRole;
  };
};

export const trackToDoCTA = makeTrackingFunction<ClickedToDoCTA>(ToDoEvent.clickedToDoCTA);

type ClickedDismissToDo = {
  eventName: ToDoEvent.clickedDismissedToDo;
  payload: {
    toDoType: ActionItemKeys;
    userType: UserRole;
    reason: NotificationResponse;
  };
};

export const trackDismissToDo = makeTrackingFunction<ClickedDismissToDo>(ToDoEvent.clickedDismissedToDo);

type ClickedSnoozeToDo = {
  eventName: ToDoEvent.clickedSnoozeToDo;
  payload: {
    toDoType: ActionItemKeys;
    userType: UserRole;
  };
};

export const trackSnoozeToDo = makeTrackingFunction<ClickedSnoozeToDo>(ToDoEvent.clickedSnoozeToDo);

type ConfirmedToDoCTA = {
  eventName: ToDoEvent.confirmedToDoCTA;
  payload: {
    toDoType: ActionItemKeys;
    userType: UserRole;
  };
};

export const trackConfirmedToDoCTA = makeTrackingFunction<ConfirmedToDoCTA>(ToDoEvent.confirmedToDoCTA);

type ConfirmedToDoDismissal = {
  eventName: ToDoEvent.confirmedToDoDismissal;
  payload: {
    toDoType: ActionItemKeys;
    userType: UserRole;
    reason: string;
  };
};

export const trackConfirmedToDoDismissal =
  makeTrackingFunction<ConfirmedToDoDismissal>(ToDoEvent.confirmedToDoDismissal);
